import { render, staticRenderFns } from "./TaskEntities.vue?vue&type=template&id=decdfcde"
import script from "./TaskEntities.vue?vue&type=script&lang=js"
export * from "./TaskEntities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports